export default __webpack_public_path__ + "static/media/TRV.bcb2130c.jpg";